import React from 'react';
import ReactDOM from 'react-dom';
import ViewContainer from './components/ViewContainer';
import 'react-app-polyfill/ie11';
import 'core-js/es';
/* import reportWebVitals from './reportWebVitals';
 */
import 'bootstrap/dist/css/bootstrap.min.css';
import './app.scss'

ReactDOM.render(
  <React.StrictMode>
    <ViewContainer />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
